import { DH } from "../utils/RouteHelper/DH";
import { RISKAI } from "../utils/RouteHelper/DTRM";
import { DT } from "../utils/RouteHelper/DTRM/DT";
import { EDM } from "../utils/RouteHelper/EDM";
import { GENAI } from "../utils/RouteHelper/GENAI";
import { DPAI } from "../utils/RouteHelper/IBP/DPAI";
import { PAI } from "../utils/RouteHelper/IBP/PAI";
import { SNOP } from "../utils/RouteHelper/IBP/SNOP";
import { SNP } from "../utils/RouteHelper/IBP/SNP";
import { ID } from "../utils/RouteHelper/InternalDashboard";
import { DS_DASHBOARD } from "../utils/RouteHelper/InternalDashboard/DS_DASHBOARD";
import { IEO } from "../utils/RouteHelper/IEO";
import { IBP } from "./RouteHelper/IBP";
import { IOP } from "./RouteHelper/IOP";
import { SS } from "./RouteHelper/IOP/SS";
import { SNOE } from "./RouteHelper/IOP/SNOE";
import { DSAI } from "./RouteHelper/IOP/DSAI";
import { CORTEX } from "./RouteHelper/CORTEX";
import { INTEGRATION } from "./RouteHelper/INTEGRATION";

export const BAR_MENU = { IBP, ID, EDM, RISKAI, DH, IOP, IEO, GENAI };
export const defaultTheme = "light";
export const URLSAFECHARS =
  "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789-_";
export const MIN_LENGTH = 58;
export const USER_KEYS = [
  "access",
  "email",
  "first_login",
  "first_name",
  "last_name",
  "mobile",
  "refresh",
  "username",
];

export const APP_MENU = {
  "Integrated Business Planning": "IBP",
  "Enterprise Data Management": "EDM",
  "Risk Management & Digital Twin": "RISKAI",
  "Internal Dashboard": "ID",
  "Data Health": "DH",
  "Integrated Operations Planning": "IOP",
  "Intelligent Execution Orchestration": "IEO",
  "Cortex": "GENAI",
};

export const STATUS_CODE = {
  OK: 200,
  CREATED: 201,
  BAD_REQUEST: 400,
};

export const SCAI_FRONTEND_ROUTES = [
  { routes: INTEGRATION, key: "INTEGRATION" },
  { routes: DS_DASHBOARD, key: "DS_DASHBOARD" },
  { routes: ID, key: "ID" },
  { routes: EDM, key: "EDM" },
  { routes: DH, key: "DH" },
  { routes: SNOP, key: "SNOP" },
  { routes: DPAI, key: "DPAI" },
  { routes: SNP, key: "SNP" },
  { routes: RISKAI, key: "RM" },
  { routes: DT, key: "DT" },
  { routes: PAI, key: "PAI" },
  { routes: SNOE, key: "SNOE" },
  { routes: GENAI, key: "GENAI" },
  { routes: IEO, key: "IEO" },
  { routes: SS, key: "SS" },
  { routes: DSAI, key: "DSAI" },
  { routes: CORTEX, key: "CORTEX" },
];
